import { c as _c } from "react/compiler-runtime";
import { useQuery } from "@tanstack/react-query";
import { commonApiFetch } from "@/services/api/common-api";
import type { ApiWaveDecision } from "@/generated/models/ApiWaveDecision";
import { QueryKey } from "@/components/react-query-wrapper/ReactQueryWrapper";
interface UseWaveDecisionsProps {
  readonly waveId: string;
  readonly enabled?: boolean | undefined;
}
export function useWaveDecisions(t0) {
  const $ = _c(15);
  const {
    waveId,
    enabled: t1
  } = t0;
  const enabled = t1 === undefined ? true : t1;
  let t2;
  let t3;
  if ($[0] !== waveId) {
    t2 = [QueryKey.WAVE_DECISIONS, {
      waveId
    }];
    t3 = async () => await commonApiFetch({
      endpoint: `waves/${waveId}/decisions`,
      params: {
        sort_direction: "DESC",
        sort: "decision_time",
        page: "1",
        page_size: "100"
      }
    });
    $[0] = waveId;
    $[1] = t2;
    $[2] = t3;
  } else {
    t2 = $[1];
    t3 = $[2];
  }
  let t4;
  if ($[3] !== enabled || $[4] !== t2 || $[5] !== t3) {
    t4 = {
      queryKey: t2,
      queryFn: t3,
      enabled,
      staleTime: 60000
    };
    $[3] = enabled;
    $[4] = t2;
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  const {
    data,
    isError,
    error,
    refetch,
    isFetching
  } = useQuery(t4);
  let t5;
  if ($[7] !== data?.data) {
    t5 = data?.data.map(_temp2).sort(_temp3) ?? [];
    $[7] = data?.data;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  const sortedDecisionPoints = t5;
  let t6;
  if ($[9] !== error || $[10] !== isError || $[11] !== isFetching || $[12] !== refetch || $[13] !== sortedDecisionPoints) {
    t6 = {
      decisionPoints: sortedDecisionPoints,
      isError,
      error,
      refetch,
      isFetching
    };
    $[9] = error;
    $[10] = isError;
    $[11] = isFetching;
    $[12] = refetch;
    $[13] = sortedDecisionPoints;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  return t6;
}
function _temp3(a_0, b_0) {
  return a_0.decision_time - b_0.decision_time;
}
function _temp2(d) {
  return {
    ...d,
    winners: d.winners.sort(_temp)
  };
}
function _temp(a, b) {
  return a.place - b.place;
}